import { render } from "./LoyaltyEventsModal.vue?vue&type=template&id=b9bd0e74"
import script from "./LoyaltyEventsModal.vue?vue&type=script&lang=js"
export * from "./LoyaltyEventsModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__